import PropTypes from "prop-types";
import {
  WALLET_TRANSACTION_ACTION,
  WALLET_TRANSACTION_ACTION_MAP,
} from "../../../../../../../constants/wallet";
import deductionIcon from "../../../../../../../assets/icons/deduction.svg";
import topupIcon from "../../../../../../../assets/icons/topup.svg";
import classes from "./WalletTransactionIcon.module.css";

const WalletTransactionIcon = (props) => {
  const { action } = props;

  const getMatchedIcon = () => {
    switch (action) {
      case WALLET_TRANSACTION_ACTION.ORDER_ITEM_WALLET_DEDUCTION:
        return deductionIcon;
      case WALLET_TRANSACTION_ACTION.MECHANIC_TOPUP:
        return topupIcon;
      default:
        return null;
    }
  };

  return (
    <img
      src={getMatchedIcon()}
      alt={WALLET_TRANSACTION_ACTION_MAP.get(action)}
      className={classes["wallet-transaction-icon"]}
    />
  );
};

export default WalletTransactionIcon;

WalletTransactionIcon.propTypes = {
  action: PropTypes.string,
};
